module.exports = __webpack_public_path__ + "img/SUFHAIRI- LOGISTICS.612e9d3f.jpg";